import React from 'react';
import {useLocaleKeys} from '../../../LocaleKeysProvider';
import {useControllerProps} from '../../ControllerContext';
import {ShippingSectionText} from './ShippingSectionText';
import settingsParams from '../../../settingsParams';
import {getFormattedAddressTranslation} from '../../../addressUtils';
import {classes} from './ShippingSectionOverride.st.css';
import {ExtendedFieldsView} from '../ExtendedFieldsView/ExtendedFieldsView';
import {useSettingsWithDefaults} from '../../../../../hooks/useSettingsWithDefaults';

export enum ShippingColumnDataHook {
  root = 'ShippingColumnDataHook.root',
  title = 'ShippingColumnDataHook.title',
  fullName = 'ShippingColumnDataHook.fullName',
  address = 'ShippingColumnDataHook.address',
  phone = 'ShippingColumnDataHook.phone',
  deliveryTime = 'PickupColumnColumnDataHook.deliveryTime',
  extendedFields = 'PickupColumnColumnDataHook.extendedFields',
}

export const ShippingColumn = () => {
  const localeKeys = useLocaleKeys();
  const {address, isEditor, isPreview, deliveryTime} = useControllerProps().thankYouPageStore;
  const {getSettingsWithDefaults} = useSettingsWithDefaults();
  const {addressLine1, addressLine2, city, country, subdivision, zipCode, fullName, phone} = address;

  const getShippingColumnTitle = () => {
    return (
      // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
      getSettingsWithDefaults(settingsParams.THANK_YOU_PAGE_SHIPPING_ADDRESS_LABEL) ??
      localeKeys.thankYouPage.shippingAddress.label()
    );
  };

  const addressData =
    isEditor || isPreview
      ? addressLine2
      : getFormattedAddressTranslation(
          {
            // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
            addressLine1,
            // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
            country,
            // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
            addressLine2,
            // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
            city,
            // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
            subdivision,
            // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
            zipCode,
          },
          localeKeys
        );

  return (
    <div data-hook={ShippingColumnDataHook.root}>
      <ShippingSectionText dataHook={ShippingColumnDataHook.title} text={getShippingColumnTitle()} isTitle={true} />
      {/* @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏 */}
      <ShippingSectionText dataHook={ShippingColumnDataHook.fullName} text={fullName} />
      <ShippingSectionText dataHook={ShippingColumnDataHook.address} text={addressData} />
      {/* @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏 */}
      <ShippingSectionText dataHook={ShippingColumnDataHook.phone} text={phone} />
      <ExtendedFieldsView />
      {deliveryTime && (
        <div className={classes.deliveryTime}>
          <ShippingSectionText dataHook={ShippingColumnDataHook.deliveryTime} text={deliveryTime} />
        </div>
      )}
    </div>
  );
};
